import LoadingModal from "../../components/loading-modal/LoadingModal"
import EcpWorkflowSettings from "../ecp-workflow-settings/EcpWorkflowSettings"
import EcpWorkflowTranscription from "../ecp-workflow-transcription/EcpWorkflowTranscription"
import EcpWorkflowRender from "../ecp-workflow-render/EcpWorkflowRender"
import EcpWorkflowIntegration from "../ecp-workflow-integration/EcpWorkflowIntegration"
import Switch from "../../tools/Switch"
import parseTries from "../../tools/parseTries"

export default function EcpWorkflowContent({params}) {
    const steps = {
        1: "upload",
        2: "transcription",
        3: "render",
        4: "integration",
    }
    let trie = parseTries(params.tries)
    let statusCode = trie.status_code
    let step = trie.step

    switch (step) {
        case "upload":
            if (statusCode === "done") {
                step = "transcription"
                params.workflowNavigation === -1 && params.setWorkflowNavigation(2)
            } else {
                params.workflowNavigation === -1 && params.setWorkflowNavigation(1)
            }
            break
        case "transcription":
            (statusCode === "in_progress" && params.workflowNavigation === -1) ? params.setWorkflowNavigation(1) :
            params.workflowNavigation === -1 && params.setWorkflowNavigation(2)
            break
        case "chunking":
        case "generate_all_ecp":
            (statusCode === "in_progress" && params.workflowNavigation === -1) ? params.setWorkflowNavigation(2) :
            params.workflowNavigation === -1 && params.setWorkflowNavigation(3)
            break
        case "abstract":
        case "summary":
        case "keypoints":
        case "verbatims":
        case "glossary":
            (statusCode === "in_progress" && params.workflowNavigation === -1) ? params.setWorkflowNavigation(3) :
            params.workflowNavigation === -1 && params.setWorkflowNavigation(3)
            break
        case "integration":
        case "finalize":
            params.workflowNavigation === -1 && params.setWorkflowNavigation(4)
            break
        default:
            break
    }

    if (params.workflowNavigation === -1 && statusCode === "in_progress") {
        params.setIsPulling(true)
    }
    else if (params.project.finished) {
        params.setMaxStep(4)
    }
    else if (params.project.generate_all_ecp_status === "done") {
        params.setMaxStep(3)
    }
    else if (params.project.transcription_status === "done") {
        params.setMaxStep(2)
    }
    else if (params.project.upload_status === "done") {
        params.setMaxStep(2)
    }

    step = steps[params.workflowNavigation]
    params.setWorkflowStep(step)
    return (
        <>
        <LoadingModal display={params.isPulling} trie={trie}/>
        <Switch value={step}>
            <EcpWorkflowSettings value={"upload"} project={params.project} mutateEcpProject={params.mutateEcpProject} setIsPulling={params.setIsPulling} setWorkflowNavigation={params.setWorkflowNavigation} setMaxStep={params.setMaxStep}/>
            <EcpWorkflowTranscription value={"transcription"} project={params.project} setIsPulling={params.setIsPulling}/>
            <EcpWorkflowRender value={"render"} project={params.project} isPulling={params.isPulling} setIsPulling={params.setIsPulling}/>
            <EcpWorkflowIntegration value={"integration"} project={params.project}/>
        </Switch>
        </>
    )
}